const NxtGen = {
    id: 0,
    main_background: '#000000',
    profile_img_border: '#000000',
    top_card_color: 'linear-gradient(195deg, #FBD40C, #F06724)',
    top_text_color: '#000000',
    btm_card_color: 'linear-gradient(30deg, #9D1C20, #ED6B32, #F4AB3B)',
    btm_text_color: '#FFFFFF',
    icon_color: '#000000',
    btn_color: '#000000',
    theme_name: 'Nxt Gen',
    background: "/images/NxtGen-Ignite.png",
    font: "'Montserrat', sans-serif",
    type: 'premium'
}

const TropicalResort = {
    id: 1,
    main_background: '#0A0B0B',
    profile_img_border: '#F7E1AC',
    top_card_color: '#918F7A',
    top_text_color: '#EEEAE1',
    btm_card_color: '#918F7A',
    btm_text_color: '#EEEAE1',
    icon_color: '#515249',
    btn_color: '#515249',
    theme_name: 'Tropical Resort 2',
    background: "/images/TropicalResort.jpg",
    font: "'Garamond', serif",
    type: 'premium'
};

const Hotel = {
    id: 2,
    main_background: '#333333',
    profile_img_border: '#000000',
    top_card_color: 'linear-gradient(0deg, #FBD40C, #F06724)',
    top_text_color: '#000000',
    btm_card_color: '#000000',
    btm_text_color: '#ffffff',
    icon_color: 'linear-gradient(0deg, #FBD40C, #F06724)',
    btn_color: '#9D1C20',
    theme_name: 'Hotel',
    background: "/images/Hotel.jpg",
    font: "'Garamond', serif",
    type: 'premium'
}

export const premium_themes = [
    NxtGen,
    TropicalResort,
    Hotel,
]